import {
  type InstallationQuotationStatus,
  type WidgetSettingsDefinition,
} from "@repo/api";
import { translateInstallationQuotationStatus } from "@repo/ui";

import { COMMON_SETTINGS } from "./commonWidgetSettings";

export const INSTALLATION_QUOTATIONS_SETTINGS: WidgetSettingsDefinition[] = [
  COMMON_SETTINGS.COWORKER,
  COMMON_SETTINGS.STORE,
  {
    id: "quotationValue",
    title: "label.value",
    type: "value_range",
  },
  {
    id: "status",
    title: "label.status",
    type: "selection",
    translator: (key: string) =>
      translateInstallationQuotationStatus(key as InstallationQuotationStatus),
    stringValues: ["DRAFT", "SENT", "ACCEPTED", "VOIDED", "NOTSIGNED"],
    additionalControl: { selectionMode: "MULTI", showSearch: false },
  },
  {
    id: "docusignDateSentFilter",
    title: "label.docusign_date_sent",
    type: "date_range",
  },
  {
    id: "depositPaid",
    title: "label.deposit_paid",
    type: "boolean",
  },
  {
    id: "installationFromDateFilter",
    title: "label.installation_from_date",
    type: "date_range",
  },
];
